<template>
  <!--
       el-container:
            主要作为容器
               当内部没有header或footer的时候，则水平方向布局
               内部有header或footer的时候，则垂直方法布局
    -->
  <el-container class="wrap aside">
    <!-- 展开 -->
    <el-aside
      width="220px"
      style="background: #f6f7fb; z-index: 1"
      v-if="leftmenu"
    >
      <div
        @mouseenter="menumouseout"
        @mouseleave="mouseleavemenu"
        class="width100"
        style="height: 100%"
      >
        <div class="elaside"></div>
        <div style="padding-left: 20px; padding-top: 15px">
          <img
            style="width: 180px;}"
            src="@/assets/barsvg/icon／logo-zh.png"
            alt=""
          />

          <!-- {{ title }} -->
        </div>
        <div class="switch cursorpointer">
          <!-- <img
          @click="changerights()"
          src="../../assets/barsvg/zk@3x.png"
          alt=""
        /> -->
          <img
            v-if="changemenu"
            @click="changelefts()"
            src="@/assets/barsvg/sq@3x.png"
            alt=""
          />
        </div>

        <Menu v-if="defaltnum" class="margin-top30"> </Menu>
        <OneMenu v-if="defaltzero" class="margin-top30"></OneMenu>
        <centerMenu v-if="Individualcenter" class="margin-top30"></centerMenu>
      </div>
    </el-aside>
    <!-- 收起 -->
    <el-aside
      width="64px"
      style="
        box-shadow: 2px 0 6px rgb(0 21 10 / 5%);
        background: #f6f7fb;
        z-index: 20;
      "
      v-if="leftSimplify"
    >
      <div class="width100" style="height: 100%">
        <div class="left-title">
          <svg
            class="enpriselogo"
            viewBox="0 0 24 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="icon/logo-组合" fill="#81C9C4">
              <path
                d="M9.57066901,18.8511684 L16.7107235,31.0161286 C15.2640713,31.6482176 13.672456,31.9999766 12.0000005,31.9999766 C11.1675514,31.9999766 10.3552552,31.9128565 9.57066901,31.7477499 L9.57066901,31.7477499 L9.57066901,18.8511684 Z M5.41517928,9.47522157 L5.41517928,29.9814606 C2.15523073,27.7877678 2.343492e-05,24.0174826 2.343492e-05,19.7284582 C2.343492e-05,15.4391996 2.15523073,11.6691486 5.41517928,9.47522157 L5.41517928,9.47522157 Z M20.2987738,10.8778079 C22.5760431,13.1113138 24.0000234,16.2469339 24.0000234,19.7284582 C24.0000234,23.2917161 22.4221488,26.5828409 20.0502986,28.8247777 L20.0502986,28.8247777 L14.1608644,18.8804426 Z M11.9999318,7.45684614 C13.8475795,7.45684614 15.568814,7.86153294 17.0772988,8.62313102 L17.0772988,8.62313102 L9.56853923,18.3229678 L9.57060031,7.70907281 C10.3551865,7.54396622 11.1677117,7.45684614 11.9999318,7.45684614 Z M9.56906595,-9.36775006e-05 L9.56906595,5.35662 L5.43338552,3.69712308 L5.43338552,-9.36775006e-05 L9.56906595,-9.36775006e-05 Z"
                id="logo"
              ></path>
            </g>
          </svg>
        </div>
        <div class="switchs cursorpointer">
          <img
            v-if="changemenu"
            @click="changerights()"
            src="@/assets/barsvg/zk@3x.png"
            alt=""
          />
          <!-- <img
          @click="changelefts()"
          src="../../assets/barsvg/sq@3x.png"
          alt=""
        /> -->
        </div>
        <Simplify v-if="defaltnum" class="margin-top10"></Simplify>
        <OneSimplify v-if="defaltzero" class="margin-top10"></OneSimplify>
        <onecenterMenu
          v-if="Individualcenter"
          class="margin-top20"
        ></onecenterMenu>
      </div>
    </el-aside>

    <el-container class="right-content">
      <el-header style="background: #f6f7fb">
        <Header v-if="defaltnum || defaltzero" />
        <Headers v-if="Individualcenter" />
      </el-header>
      <el-main class="el-main width100">
        <!-- <div class="width100 margin-auto quickbtn">
          <div class="width99 flex overhide">
            <div class="breadcont" @click="tohead()" v-if="headcont">首页</div>
            <div
              class="breadcont cursorpointer"
              v-for="(item, index) in levelList"
              :key="index"
              :class="breadname == item.name ? 'bread' : 'tobread'"
              @contextmenu.prevent="openMenu($event, item)"
            >
              <span @click="tobread(index)" class="f12">
                <div
                  class="redios"
                  v-if="breadname == item.name ? true : false"
                ></div>
                {{ item.name }}</span
              >
              <span class="f14 pad-left5" @click="removebread(index)">
                <i class="el-icon-close" style="font-size: 12px"></i
              ></span>
              <div v-if="rightcont == item.name" class="rightbtn">
                <ul
                  :style="{ left: left + 'px', top: top + 'px' }"
                  class="contextmenu"
                >
                  <li @click="refreshSelectedTag">
                    <i class="el-icon-refresh-right"></i> 刷新页面
                  </li>
                  <li @click="closeSelectedTag">
                    <i class="el-icon-close"></i> 关闭当前
                  </li>
                  <li @click="closeOthersTags" v-if="levelList.length > 1">
                    <i class="el-icon-circle-close"></i> 关闭其他
                  </li>
                  <li
                    @click="closeLeftTags"
                    v-if="index != 0 && levelList.length > 1"
                  >
                    <i class="el-icon-back"></i> 关闭左侧
                  </li>
                  <li
                    @click="closeRightTags"
                    v-if="index + 1 < levelList.length && levelList.length > 1"
                  >
                    <i class="el-icon-right"></i> 关闭右侧
                  </li>
                  <li @click="closeAllTags">
                    <i class="el-icon-circle-close"></i> 全部关闭
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> -->
        <div
          class="width98 flex f12 margin-left20 margin-top10"
          style="color: #969eac"
          v-if="smalltit != null"
        >
          <span>当前位置： </span>
          <span
            class="pad-left5 pad-right5 cursorpointer"
            @click="tohead"
            v-if="this.default != '个人中心'"
          >
            <span class="pad-right5"> 首页 </span> <span> /</span>
          </span>
          <span class="pad-right5">{{ bigtit }} </span> /<span
            class="pad-left5"
            style="color: #52c5cb"
            >{{ smalltit }}</span
          >
        </div>
        <router-view
          class="margin-top10 width98 margin-auto"
          style="position: relative"
        ></router-view>
      </el-main>
    </el-container>
    <el-dialog title="移动端二维码" :visible.sync="dialogVisible" width="30%">
      <img
        @click="reseachewm()"
        style="width: 100%; height: 100%"
        :src="avcter"
      />
    </el-dialog>
  </el-container>
</template>

<script>
// 引入全局公共组件
import Menu from "@/components/Menu";
import Header from "@/components/Header";
import Headers from "@/components/Headers";
import OneMenu from "@/components/oneMenu.vue";
import centerMenu from "@/components/centerMenu.vue";
import onecenterMenu from "@/components/onecenterMenu.vue";
import Simplify from "@/components/Simplify.vue";
import OneSimplify from "@/components/OneSimplify.vue";
import BUS from "@/BUS/BUS";
import { authqr, config } from "@/api/login/login.api";

export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisible: false,
      page: [],
      activepath: [],
      value: true,
      input: "",
      defaltzero: false,
      defaltnum: true,
      Individualcenter: false,
      leftSimplify: false,
      leftmenu: true,
      default: "",
      serchkey: "",
      breadList: [], // 路由集合
      avcter: "",
      title: "",
      levelList: [],
      breadname: "",
      headcont: false,
      rightcont: false,
      left: 0,
      top: 0,
      itemcont: {},
      maxx: "",
      minix: "",
      maxy: "",
      miniy: "",
      screenWidth: "",
      changemenu: false,
      bigtit: "",
      smalltit: "",
    };
  },
  components: {
    Menu,
    Header,
    Headers,
    OneMenu,
    centerMenu,
    Simplify,
    OneSimplify,
    onecenterMenu,
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
    levelList() {
      if (this.levelList.length == 0) {
        this.headcont = true;
      } else {
        this.headcont = false;
      }
    },
    screenWidth: function (n, o) {
      if (n <= 1200 && this.default != 1) {
        this.leftSimplify = true;
        this.leftmenu = false;
        BUS.$emit("indent", true);
        BUS.$emit("scrollwidth", n);
        // location.reload();
      } else {
        this.leftmenu = true;
        this.leftSimplify = false;
        BUS.$emit("indent", false);
        BUS.$emit("scrollwidth", n);
      }

      // location.reload();
    },
    default() {
      if (this.default == 0) {
        this.defaltzero = true;
        this.defaltnum = false;
        this.Individualcenter = false;
      } else if (this.default == "个人中心") {
        this.defaltzero = false;
        this.defaltnum = false;
        this.Individualcenter = true;
      } else {
        this.defaltnum = true;
        this.defaltzero = false;
        this.Individualcenter = false;
      }
    },
  },
  methods: {
    changelefts() {
      this.leftmenu = false;
      this.leftSimplify = true;
    },
    changerights() {
      this.leftmenu = true;
      this.leftSimplify = false;
    },
    // handleonmousedown(e) {
    //   if (
    //     this.minix < e.x &&
    //     e.x < this.maxx &&
    //     this.miniy < e.y &&
    //     e.y < this.maxy
    //   ) {
    //     console.log("满足");
    //   } else {
    //     this.rightcont = "";
    //   }
    // },
    // // 右键点击
    // openMenu(e, item) {
    //   this.maxx = e.x + 80;
    //   this.minix = e.x - 80;
    //   this.maxy = e.y + 180;
    //   this.miniy = e.y - 180;
    //   this.rightcont = item.name;
    //   this.itemcont = item;
    // },
    // // 刷新
    // refreshSelectedTag() {
    //   this.$loading.show(); // 显示loading
    //   setTimeout(() => {
    //     this.$loading.hide(); // 隐藏loading
    //     this.rightcont = "";
    //   }, 200);
    // },
    // // 关闭当前
    // closeSelectedTag() {
    //   this.rightcont = "";
    //   if (this.itemcont.name == this.$route.matched[1].meta.name) {
    //     if (this.levelList.length <= 1) {
    //       this.levelList.splice(this.levelList.indexOf(this.itemcont), 1);
    //       this.$router.push({
    //         path: "/home/homepage",
    //       });
    //     } else {
    //       let itemindex = this.levelList.indexOf(this.itemcont);
    //       this.levelList.splice(this.levelList.indexOf(this.itemcont), 1);
    //       this.$router.push({
    //         path: this.levelList[itemindex - 1].path,
    //       });
    //     }
    //   } else {
    //     if (this.levelList.length <= 1) {
    //       this.levelList.splice(this.levelList.indexOf(this.itemcont), 1);
    //       this.$router.push({
    //         path: "/home/homepage",
    //       });
    //     } else {
    //       let itemindex = this.levelList.indexOf(this.itemcont);
    //       this.levelList.splice(this.levelList.indexOf(this.itemcont), 1);
    //       // this.$router.push({
    //       //   path: this.levelList[itemindex - 1].path,
    //       // });
    //     }
    //   }
    // },
    // // 关闭其他
    // closeOthersTags() {
    //   this.rightcont = "";
    //   this.levelList = [];
    //   this.levelList.push(this.itemcont);
    //   this.$router.push({
    //     path: this.itemcont.path,
    //   });
    // },
    // // 关闭左侧
    // closeLeftTags() {
    //   this.rightcont = "";
    //   this.levelList.splice(0, this.levelList.indexOf(this.itemcont));
    //   this.$router.push({
    //     path: this.itemcont.path,
    //   });
    // },
    // // 关闭右侧
    // closeRightTags() {
    //   this.rightcont = "";
    //   this.levelList.splice(
    //     this.levelList.indexOf(this.itemcont) + 1,
    //     this.levelList.length - (this.levelList.indexOf(this.itemcont) + 1)
    //   );
    //   this.$router.push({
    //     path: this.itemcont.path,
    //   });
    // },
    // // 全部关闭
    // closeAllTags() {
    //   this.rightcont = "";
    //   this.levelList = [];
    //   this.$router.push({
    //     path: "/home/homepage",
    //   });
    // },
    // getBreadcrumb() {
    //   let routecont = {};
    //   if (this.$route.matched[1].meta.name == undefined) {
    //     routecont.name = "首页";
    //     routecont.path = "/home/homepage";
    //     this.breadname = "首页";
    //   } else {
    //     routecont.name = this.$route.matched[1].meta.name;
    //     routecont.path = this.$route.matched[1].path;
    //     this.breadname = this.$route.matched[1].meta.name;
    //   }
    //   if (
    //     JSON.stringify(this.levelList).indexOf(JSON.stringify(routecont)) === -1
    //   ) {
    //     this.levelList.push(routecont); // 进行动态的操作
    //   }
    // },
    // tohead() {
    //   this.$router.push({
    //     path: "/home/homepage",
    //   });
    // },
    // tobread(index) {
    //   this.rightcont = "";
    //   this.$router.push({
    //     path: this.levelList[index].path,
    //   });
    // },
    // removebread(index) {
    //   if (this.levelList[index].name == this.$route.matched[1].meta.name) {
    //     if (this.levelList.length == 1) {
    //       this.levelList.splice(index, 1);
    //       this.$router.push({
    //         path: "/home/homepage",
    //       });
    //     } else {
    //       if (index == 0) {
    //         this.levelList.splice(index, 1);
    //         this.$router.push({
    //           path: this.levelList[index].path,
    //         });
    //       } else {
    //         this.levelList.splice(index, 1);
    //         this.$router.push({
    //           path: this.levelList[index - 1].path,
    //         });
    //       }
    //     }
    //   } else {
    //     if (this.levelList.length == 1) {
    //       this.levelList.splice(index, 1);
    //       this.$router.push({
    //         path: "/home/homepage",
    //       });
    //     } else {
    //       if (index == 0) {
    //         this.levelList.splice(index, 1);
    //         this.$router.push({
    //           path: this.levelList[index].path,
    //         });
    //       } else {
    //         this.levelList.splice(index, 1);
    //         // this.$router.push({
    //         //   path: this.levelList[index - 1].path,
    //         // });
    //       }
    //     }
    //   }

    //   // if (this.levelList.length == 1) {
    //   //   this.levelList.splice(index, 1);
    //   //   this.$router.push({
    //   //     path: "/home/homepage",
    //   //   });
    //   // } else {
    //   //   if (index == 0) {
    //   //     this.levelList.splice(index, 1);
    //   //     this.$router.push({
    //   //       path: this.levelList[index].path,
    //   //     });
    //   //   } else {
    //   //     this.levelList.splice(index, 1);
    //   //     this.$router.push({
    //   //       path: this.levelList[index - 1].path,
    //   //     });
    //   //   }
    //   // }
    // },
    getBreadcrumb() {
      this.bigtit = this.$route.matched[0].meta.name;
      this.smalltit = this.$route.matched[1].meta.name;
    },
    tohead() {
      this.$router.push({
        path: "/home/homepage",
      });
    },
    reseachewm() {
      authqr({ responseType: "blob" }).then((res) => {
        this.avcter = res.data.data;
      });
    },
    menumouseout() {
      this.changemenu = true;
    },
    mouseleavemenu() {
      this.changemenu = false;
    },
  },

  created() {
    config().then((res) => {
      this.title = res.data.data.title;
    });

    authqr({ responseType: "blob" }).then((res) => {
      this.avcter = res.data.data;
    });

    this.getBreadcrumb();

    BUS.$on("serchkey", (data) => {
      this.value = data;
    });

    BUS.$on("dialogVisible", (data) => {
      if (data == 1) {
        this.dialogVisible = true;
      }
    });
    BUS.$on("default", (data) => {
      if (data == 0) {
        this.defaltzero = true;
        this.defaltnum = false;
        this.Individualcenter = false;
      } else if (data == "个人中心") {
        this.default = "个人中心";
        this.defaltzero = false;
        this.defaltnum = false;
        this.Individualcenter = true;
      } else {
        this.defaltnum = true;
        this.defaltzero = false;
        this.Individualcenter = false;
      }
    });

    this.default = window.sessionStorage.getItem("default");
    if (window.sessionStorage.getItem("default") == 0) {
      this.defaltzero = true;
      this.defaltnum = false;
      this.Individualcenter = false;
    } else if (window.sessionStorage.getItem("default") == "个人中心") {
      this.defaltzero = false;
      this.defaltnum = false;
      this.Individualcenter = true;
    } else {
      this.defaltnum = true;
      this.defaltzero = false;
      this.Individualcenter = false;
    }

    BUS.$on("leftSimplify", (data) => {
      if (data == true) {
        this.leftSimplify = true;
        this.leftmenu = false;
      } else if (data == false) {
        this.leftSimplify = false;
        this.leftmenu = true;
      }
    });

    BUS.$on("removehistory", (data) => {
      if (data == true) {
        this.page = [];
      }
    });
  },
  mounted() {
    BUS.$on("menumou", (data) => {
      if (data == 111) {
        this.changemenu = true;
      } else {
        this.changemenu = false;
      }
    });
    document.querySelector(".el-main").style.height =
      document.documentElement.clientHeight - 60 + "px";
    // document.querySelector(".switch").style.position = "absolute";
    // document.querySelector(".switch").style.top =
    //   document.documentElement.clientHeight / 2 - 20 + "px";
    window.addEventListener("mousedown", this.handleonmousedown);

    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      // console.log('高度');
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
};
</script>

<style scoped>
/* .hasTagsView {
  min-height: calc(100vh - 110px);
  background: #fff;
} */
.switch img {
  width: 10px;
  height: 60px;
  z-index: 30;
  position: absolute;
  left: 220px;
  top: 400px;
}
.switchs img {
  width: 10px;
  height: 60px;
  z-index: 30;
  position: absolute;
  left: 65px;
  top: 400px;
}
.left-title {
  width: 100%;
  /* height: 80px; */
  text-align: center;
  line-height: 80px;
}
.right-content {
  background: #fff;
}
.wrap >>> .el-card__body,
.el-main {
  height: 100vh;
  margin: 0;
  padding: 0;
  background: #f6f7fb;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.wrap >>> ::-webkit-scrollbar {
  display: none;
  width: 0 !important;
}
.aside >>> .el-aside {
  /* border-right: 1px solid #e4e4e4; */
  /* padding-bottom: 62px; */
  overflow: hidden;
}
.quickbtn {
  background: #fff;
  height: 36px;
  border-bottom: 1px solid #e9e7e7;
  border-top: 1px solid #f7f4f4;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 2px 2px 5px #dfdede;
  margin-bottom: 2px;
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #101010 !important;
  font-weight: 500;
}
.crumbitem >>> .el-breadcrumb__separator {
  margin: 0;
}
.svgfff {
  /* stroke: white; */
  position: relative;
  top: 4px;
  width: 18px;
  fill: white;
}
.enpriselogo {
  width: 34px;
  height: 34px;
  margin-top: 14px;
}
.enprisecont {
  width: 80px;
  height: 80px;
  margin: -5px 0 0 5px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.breadcont {
  font-size: 13px;
  border: 1px solid #d8dce5;
  height: 25px;
  line-height: 25px;
  padding: 0 10px 0 10px;
  margin-left: 5px;
  display: flex;
  justify-content: space-around;
}
.rightbtn {
  /* width: 50px;
  height: 100px; */
  background: #409eff;
  position: absolute;
  top: 100px;
  z-index: 300;
}
.bread {
  background: #409eff;
  color: #fff;
  padding: 1px 10px 1px 10px;
  border: none;
}
.redios {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
  margin-right: 3px;
}
.contextmenu {
  margin: 0;
  background: #fff;
  padding: 5px 0;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}
li {
  margin: 0;
  padding: 1px 8px;
  cursor: pointer;
}
li:hover {
  background: #eee;
}
.elaside {
  height: 100%;
  width: 10px;
  background: #f6f7fb;
  /* z-index: 20; */
  position: absolute;
  left: 210px;
  border-radius: 33%;
  box-shadow: 4px 81px 7px rgb(17 17 17 / 5%);
}
</style>
